import { Typography } from "@mui/material";
import React, { useState } from "react";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import { CustomizeSpan } from "../../style";
import HoverHaileyIco from "../../../../assets/icons/HoverHaileyIco";
import CommonButton from "../../../../component/Button";
import HaileyStartIco from "../../../../assets/icons/HaileyStartIco";

export default function Predictions({
  data,
  name,
  icon,
  checkWidth,
  handleQuestionMarkClick,
  chatBotData,
  value,
}) {
  const [hovered, setHovered] = useState(false);

  return (
    <CommonGrid2
      background="#F5F6F7"
      padding={"1rem"}
      borderRadius={"10px"}
      item
      size={{
        xs: 12,
        md: checkWidth < 850 ? 6 : 4,
        sm: checkWidth < 650 ? 12 : 6,
      }}
      onMouseLeave={() => setHovered(false)}
    >
      <CommonGrid2 display={"flex"} gap={"1rem"}>
        {icon}
        <CommonGrid2 display={"flex"} flexDirection={"column"} gap={"8px"}>
          <Typography variant="h6" fontWeight={600}>
            {name}
          </Typography>
          <CommonGrid2 display={"flex"} flexWrap={"wrap"} gap={"8px"}>
            <CommonGrid2
              border="1px solid #EAECF0"
              padding="2px 10px 2px 3px"
              borderRadius="50px"
              background="#fff"
              width={"max-content"}
            >
              <CustomizeSpan
                width={"max-content"}
                color="#fff"
                background={
                  Math.ceil(data.final_score) > 80
                    ? "#079455"
                    : Math.ceil(data.final_score) > 50
                    ? "#F79009"
                    : "#7F56D9"
                }
                padding="2px 7px"
                borderRadius={"50px"}
                fontSize="13px"
                fontWeight={700}
              >
                {Math.ceil(data.final_score)}%
              </CustomizeSpan>
              <CustomizeSpan margin="0px 0px 0px 10px">
                {data.label}
              </CustomizeSpan>
            </CommonGrid2>
            <CommonGrid2
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
            >
              {hovered ? (
                <CommonButton
                  value={"Ask Hailey"}
                  fontSize={"13px"}
                  padding={"2px 10px 2px 1rem"}
                  gap={"0px"}
                  startIcon={<HaileyStartIco />}
                  borderRadius="50px"
                  onClick={() =>
                    handleQuestionMarkClick(
                      chatBotData.geminiBubble &&
                        chatBotData.geminiBubble.length !== 0
                        ? chatBotData.geminiBubble.filter(
                            (item) => item.question === value
                          )[0]
                        : chatBotData.bubble.filter(
                            (item) => item.question === value
                          )[0]
                    )
                  }
                />
              ) : (
                <HoverHaileyIco />
              )}
            </CommonGrid2>
          </CommonGrid2>
        </CommonGrid2>
      </CommonGrid2>
    </CommonGrid2>
  );
}
